import { useEffect, useMemo, useRef } from 'react';

import { routeChangeFingerprint } from './routeChangeFingerprint';

// Refetches ROUTE_QUERY when ROUTE_CHANGE_SUBSCRIPTION reports the route changed. Extracted so
// the sequencing is testable — no server contract enforces it.
export const useRouteRefresh = ({ routeUid, changeData, refetch }) => {
    const fingerprint = useMemo(() => routeChangeFingerprint(changeData?.routes_by_pk), [changeData]);
    const lastSeen = useRef({ routeUid: null, fingerprint: null });

    useEffect(() => {
        if (!fingerprint) return;

        const { routeUid: seenRoute, fingerprint: seenFingerprint } = lastSeen.current;
        const firstForRoute = seenRoute !== routeUid;
        lastSeen.current = { routeUid, fingerprint };

        // A route's first delivery seeds rather than refetches: useQuery has already fetched for
        // these variables. Leaves a narrow window between that fetch and this delivery, which
        // ROUTE_QUERY's poll bounds.
        if (firstForRoute || seenFingerprint === fingerprint) return;

        // Swallowed, not reported — useQuery's onError captures this same rejection.
        refetch().catch(() => {});
    }, [fingerprint, routeUid, refetch]);
};
